/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Tickets_Tab_OpenInputs */

const en_admin_tickets_tab_open = /** @type {(inputs: Admin_Tickets_Tab_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open`)
};

const zh_admin_tickets_tab_open = /** @type {(inputs: Admin_Tickets_Tab_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`待处理`)
};

/**
* | output |
* | --- |
* | "Open" |
*
* @param {Admin_Tickets_Tab_OpenInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_tickets_tab_open = /** @type {((inputs?: Admin_Tickets_Tab_OpenInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Tickets_Tab_OpenInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_tickets_tab_open(inputs)
	return zh_admin_tickets_tab_open(inputs)
});
export { admin_tickets_tab_open as "admin.tickets.tab_open" }